import { getConfig } from "@jti/fe-common";
import { getIsEvo } from "../../utils";
import { ReferralApiEvo } from "./ReferralApiEvo";
import { ReferralApiLegacy } from "./ReferralApiLegacy";
export class ReferralApi {
    static init() {
        const { REFERRAL_URL, REFERRAL_TOKEN, "X-RECAPTCHA-ID": recaptchaId } = getConfig();
        if (getIsEvo(REFERRAL_URL)) {
            return new ReferralApiEvo(REFERRAL_URL, REFERRAL_TOKEN, recaptchaId);
        }
        return new ReferralApiLegacy(REFERRAL_URL, REFERRAL_TOKEN);
    }
}
//# sourceMappingURL=ReferralApi.js.map